module.exports = __webpack_public_path__ + "static/fonts/Oxanium-VariableFont_wght.81de8d6e.ttf";